export const dict = {
    'task_type': [
        {
            dictLabel: '任务',
            dictValue: '1'
        },
        {
            dictLabel: '需求',
            dictValue: '2'
        },
        {
            dictLabel: '缺陷',
            dictValue: '3'
        },
        {
            dictLabel: '改进',
            dictValue: '4'
        },
        {
            dictLabel: '漏洞',
            dictValue: '5'
        },
    ],
    "task_level":[
        {
            dictLabel: '低',
            dictValue: '1'
        },
        {
            dictLabel: '中',
            dictValue: '2'
        },
        {
            dictLabel: '高',
            dictValue: '3'
        },
        {
            dictLabel: '紧急',
            dictValue: '4'
        }
    ],
    "task_status":[
        {
            dictLabel: '待执行',
            dictValue: '1'
        },
        {
            dictLabel: '执行中',
            dictValue: '2'
        },
        {
            dictLabel: '待确认',
            dictValue: '3'
        },
        {
            dictLabel: '已完成',
            dictValue: '4'
        },
        {
            dictLabel: '已作废',
            dictValue: '5'
        }
    ],
    "invoice_status":[
        {
            dictLabel: '未开票',
            dictValue: '0'
        },
        {
            dictLabel: '已开票',
            dictValue: '1'
        },
        {
            dictLabel: '审批中',
            dictValue: '2'
        },
    ]
}